import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatRadioChange } from '@angular/material/radio';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FilterDateIntervalMultipleChoice, FilterMultipleChoice } from '../../../lib/model/Filter';
import { FilterService } from '../../../lib/services/filter.service';

@Component({
  selector: 'app-filter-multiple-choice',
  templateUrl: './filter-multiple-choice.component.html',
  styleUrls: ['./filter-multiple-choice.component.scss'],
})
export class FilterMultipleChoiceComponent implements OnInit, OnDestroy {
  /**
   * Subscription to filter service to auto update the filter upon request.
   */
  private filterServiceSubscription: Subscription;
  /**
   * The filter to initialize the component with.
   */
  @Input() filter: FilterMultipleChoice;
  /**
   * Emit the filter upon update.
   */
  @Output() filterUpdated: EventEmitter<FilterMultipleChoice> = new EventEmitter();
  /**
   * The user input for search.
   */
  searchTerm: Subject<string> = new Subject<string>();
  filterTerm: string;

  constructor(private filterService: FilterService) { }

  ngOnInit() {
    this.filterServiceSubscription = this.filterService.filterSubject.subscribe((filter) => {
      if (filter.id === this.filter.id) {
        this.filter = <FilterMultipleChoice>filter;
        this.filterUpdated.emit(this.filter);
      }
    });

    this.searchTerm.pipe(debounceTime(400)).subscribe((data) => {
      this.filterTerm = data.toLocaleLowerCase();
    });
  }

  ngOnDestroy() {
    this.filterServiceSubscription.unsubscribe();
  }

  toggleVisibility() {
    this.filter.visible = !this.filter.visible;
  }

  updateSelected(id: string, $event: MatCheckboxChange) {
    const index: number = this.filter.selected.indexOf(id);
    // If already selected, unselect...
    if (index > -1) {
      this.filter.selected.splice(index, 1);
    } else { // Else select it
      this.filter.selected.push(id);
    }
    this.filterUpdated.emit(this.filter);
  }
}
